{ useCoffeeCallback, useCoffeeMemo, useI18n } = require 'lib/react_utils'

OutcomeThresholds = ({ outcome, thresholdType }) ->
  i18n = useI18n('nma:thresholds')

  isContinuous = outcome.get('type') is 'cont'

  thresholds = switch thresholdType
    when 'MagnitudeOfEffect'
      ['T1', 'T2', 'T3']
    when 'MinimallyImportantDifferences'
      ['T1']
    else
      []

  <div className="flex items-center">
    {thresholds.map (threshold, idx) ->
      <React.Fragment key={threshold}>
        {if isContinuous
          <span className="inline-block mr-5">
            {i18n(threshold)}: {i18n('cont_outcome_threshold', {
              value: outcome.get(threshold),
              units: outcome.get('units', '')
            })}
          </span>
        else
          <span className="inline-block mr-5">
            {i18n(threshold)}: {i18n('dich_outcome_threshold', {
              value: outcome.get(threshold),
              denominator: outcome.get('denominator', 1000)
            })}
          </span>
        }
        {if idx < thresholds.length - 1
          <span className="inline-block mr-5">|</span>
        }
      </React.Fragment>

    }
  </div>


module.exports = OutcomeThresholds
